// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widgets-wrapper[data-v-d4de4458]{position:absolute;top:0;left:-webkit-calc(100% - 90px);left:calc(100% - 90px);width:54px;height:100%;z-index:999;pointer-events:none;padding-left:5px}@media (max-width:1399px){.widgets-wrapper[data-v-d4de4458]{padding-left:20px;left:-webkit-calc(100% - 90px);left:calc(100% - 90px)}}@media (max-width:1199px){.widgets-wrapper[data-v-d4de4458]{position:fixed;right:-100%}}", ""]);
// Exports
module.exports = exports;
